export const PROCESO_SELECT = [
  { code: "REPORTE RUTA", name: "REPORTE RUTA" }
  , { code: "IMPORTAR DIRECCIONES CORE", name: "IMPORTAR DIRECCIONES CORE" }
  , { code: "CONSULTA REP MOVIL", name: "CONSULTA REP MOVIL" }
  , { code: "ACTUALIZAR DIRECCION SE", name: "ACTUALIZAR DIRECCION SE" }
  , { code: "IMPORTAR BASES", name: "IMPORTAR BASES" }
  , { code: "IMPORTAR DIRECCIONES", name: "IMPORTAR DIRECCIONES" }
];

export const SERVICIO_SELECT = [
  { code: "MAPBOX", name: "MAPBOX" }
  , { code: "GOOGLE", name: "GOOGLE" }
];



// WEBPACK FOOTER //
// ./src/constants/bitacoraGeolocalizacion.js